import { defineVariants } from "@/runtime/style-engine/define-variants";

/**
 * Tailwind-like class variants for `<e-icon>`.
 */
export const iconClasses = defineVariants({
  base: `
    grid
    place-items-center
    overflow-hidden
    text-inherit
  `,
  variants: {
    size: {
      xl: `size-10`,
      lg: `size-8`,
      md: `size-6`,
      sm: `size-4`,
      xs: `size-3`,
    },
  },

  compoundVariants: [
    {
      size: undefined,
      class: "w-[1em] h-[1em] !inline-block align-[-0.125em]",
    },
  ],

  defaults: {},
});
